<script>
import restaurantMixin from '@/modules/mixins/restaurant'
import { EventBus } from '@/modules/plugins/modules/event'
import Vue from 'vue'
const cart = Vue.prototype.$cart

export default {
    name: 'Restaurant',
    mixins: [restaurantMixin],
    async beforeRouteEnter(to, from, next) {
        next(async (vm) => {
            try {
                await vm.$location.check(to)
                await restaurantMixin.methods.prepareCanteen(to.params?.id, to.params?.type)
                await restaurantMixin.methods.fetchRestaurant(to.params)
                await restaurantMixin.methods.setRestaurant(to.params, cart, true)
                vm.setMetaTitle()
            } catch {
                vm.$router.replace({ name: 'not-found' })
            } finally {
                vm.pageLoading = false
            }
        })
    },
    computed: {
        backRoute() {
            if (this.$route.name === 'restaurant-canteen') {
                return { name: 'canteen-pickup' }
            }

            const query = this.$route.query
            delete query['bannerId']

            return { name: 'restaurant-list', query: query, hash: this.$route.hash }
        },
    },
    beforeDestroy() {
        this.cart.resetTemporary()
        EventBus.$off('language')
    },
}
</script>

<template lang="pug">
transition(name="fade" mode="out-in")
    spinner.full-center.position-sticky(v-if="pageLoading")
    //- restaurant-skeleton(v-if="pageLoading")
    .restaurant-page.pt-md-page.pb-md-page(v-else)
        .row
            .col-12(v-if="!$user.onlyCloudCanteen")
                canteen-alert(:restaurant="restaurant")
            .col-12.col-md-8(:class="{'px-0': smDevice}")
                image-wrapper.restaurant-cover(
                    :src="cover"
                    :tag="$t('tags.restaurant', {name: restaurant.name})"
                    :height="coverHeight"
                    cover)
                router-link.btn.btn-white-primary.btn-icon.rounded-circle.shadow-5.position-absolute.top-0.left-4.m-4(:to="backRoute")
                    icon(icon="fa-solid fa-arrow-left" size="lg")
            .col-md-4(v-if="lgDevice")
                restaurant-details.mt-6.mt-md-0.h-100(:restaurant="restaurant" :allowance="allowance")
            .col-12(v-if="lgDevice")
                alert-delivery.mt-4(:restaurant="restaurant")
                // alert-group-order.mt-4
            .col-12.col-md-8
                delivery-details(v-if="smDevice" sticky stretch)
                category-navigation.mb-5(:categories="sortedCategories" :active-id="activeMenu.id" ref="categoryNav")
                template(v-if="smDevice")
                    restaurant-details.mt-6.mt-md-0(:restaurant="restaurant" :allowance="allowance")
                    alert-delivery.mt-4(:restaurant="restaurant")
                    alert-group-order.mt-4
                restaurant-banner.mb-5(v-if="restaurant.banner" :restaurant="restaurant")
                restaurant-menu(:categories="sortedCategories" :meal="meal" :restaurant="restaurant.root" :eager="!!$route.params.menu" @input="setMetaTitle" ref="menu")
            .col-12.col-md-4(v-if="lgDevice")
                cart-block.my-5(:restaurant="restaurant" @go-to-checkout="disconnectNavigationObserver")
        modal-delivery-state-change
</template>
